// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"4be0a9f2bd6a262babae","258":"ccc576b1279da47cb425"}[chunkId] + ".js";
};